import { makeServicesTypesFromEnum } from '@/core/container/makeServicesTypes'

enum FORGOT_PASSWORD_SERVICES {
  ForgotPasswordFormService,
}

export type ForgotPasswordServices = keyof typeof FORGOT_PASSWORD_SERVICES

export const FORGOT_PASSWORD_SERVICE_TYPES = makeServicesTypesFromEnum<ForgotPasswordServices>(FORGOT_PASSWORD_SERVICES)
